export default "__VITE_ASSET__aac046b6__"